import { Stack } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import * as S from '../../AnomaliesSidebar.styled';
import { timelineLabel } from '@shared';
import { ReactNode } from 'react';

export function Time({
  fontSize,
  time,
  customIcon,
}: {
  fontSize?: number | string;
  time: number;
  customIcon?: ReactNode;
}) {
  return (
    <Stack direction='row' gap={1} alignItems='center'>
      {customIcon ?? (
        <AccessTimeIcon opacity={0.8} fontSize='small' sx={{ transform: 'scale(0.8)' }} />
      )}
      <S.StopWatch sx={{ fontSize: fontSize ?? 14 }}>{timelineLabel(time)}</S.StopWatch>
    </Stack>
  );
}
